import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetListResolution886ReportParams {
	organization_id: string;
	company_id: string;
	sector_id?: string;
	line_id?: string;
	workstation_id?: string;
	evaluation_name?: string;
	workers_number?: number;
	worker_list_id?: string[];
	written_work_procedure?: boolean;
	training?: boolean;
	early_manifestation?: boolean;
	symptom_location?: boolean;
	limit: number;
	offset: number;
}

const Service = Resolution886ReportService.getInstance();

export const useGetListResolution886Report = (params: GetListResolution886ReportParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_RESOLUTION_886, params],
		queryFn: async () => Service.index(params),
		enabled: isEnabled
	});
};
